export enum CardType {
  FIRST_TYPE='firstType',
  SECOND_TYPE='secondType',
  THIRED_TYPE='thiredType'

}
